import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutCarrierCancellationsDetail } from "./autogen/AutogenLayoutCarrierCancellationsDetail";
import { ModelRow } from "@mcleod/core";

export class CarrierCancellationsDetail extends AutogenLayoutCarrierCancellationsDetail {
    textboxReasonCodesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.code_type = 'U';
        event.filter.is_active = 'Y';
    }
}